export const copy = {
  PhotoUploaderPageHeader: 'Upload Photos',
  PhotoUploaderInstructions:
    'Upload photos that will be added to your Campanion album and the Campanion stream for your parents to view.',
}
